import React from 'react'
import Card from '../components/Card'
//import { Link } from 'react-router-dom'

export default function Messages() {
  return (
    <div className="container">
      <section className="card" style={{display:'flex', gap:12}}>
        <div style={{width:260}}>
          <h3 className="h2">Conversations</h3>
          <Card style={{marginTop:12}}><div style={{fontWeight:700}}>Sarah P.</div><div className="kv">Active • 2 unread</div></Card>
          <Card style={{marginTop:12}}><div style={{fontWeight:700}}>Ryan S.</div><div className="kv">Last seen 3d ago</div></Card>
        </div>

        <div style={{flex:1, display:'flex', flexDirection:'column', minHeight:320}}>
          <div className="card" style={{flex:1, overflow:'auto'}}>
            <div style={{maxWidth:'70%', marginLeft:'auto', background:'var(--accent-100)', padding:10, borderRadius:10, marginBottom:8}}>Thanks — I'll review these receipts.</div>
            <div style={{maxWidth:'70%', background:'#f3f6fb', padding:10, borderRadius:10, marginBottom:8}}>Uploaded the bank statement via upload page.</div>
          </div>

          <form style={{display:'flex', gap:8, marginTop:8}} onSubmit={(e)=>{e.preventDefault(); alert('Send message')}}>
            <input placeholder="Type a message" style={{padding:12, borderRadius:8, border:'1px solid #eef6ff', flex:1}} />
            <button className="btn primary">Send</button>
          </form>
        </div>
      </section>
    </div>
  )
}
